import {ConfirmDialog} from "../ConfirmDialog";
import { _ } from "../../Lang.class.js";


class LabelMenuElement {

    getLabelMenuElement(key: string, label: string, isSelected: boolean, isUsed: boolean,  hasSubMenu: boolean, disableUsedLabel: boolean, callbacks: { reload: () => void, onLabelClick: (key: string) => boolean }) {

        const reload = () => {
            if (callbacks.onLabelClick(key)) {
                div.classList.add('open');
                callbacks.reload();
            }
        }

        let div = document.createElement('div');
        div.setAttribute('filter_key', key);
        div.setAttribute('class', `menu_filter_label ${(isSelected ? ' open ' : '')} ${(isUsed ? ' chosen ' : '')} `);
        div.innerHTML = _(label);
        div.addEventListener('click', () => {
            console.log('FilterEditorItem, getLabelElement, click', key);
            if (isUsed && !disableUsedLabel && !hasSubMenu) {
                console.log('FilterEditorItem, getLabelElement, click, confirm', confirm);

                // confirm.show();
                if (confirm('Ten filtr jest już ustawiony, czy chcesz go edytować?')) {
                    reload();
                }
            } else {
                console.log('FilterEditorItem, getLabelElement, click, reload');
                reload();
            }
        });
        return div;
    }

}

export default LabelMenuElement;